(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-product-grid-alt"] && !Shopify.designMode) return;
  try {
    
  /* Optional JS for interactions can go here */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      //this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-homepage-gsap-animation"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function() {
    gsap.registerPlugin(ScrollTrigger);
    gsap.set(".jd-video-content", {opacity: 0});

    function jdSetContentElements(progress) {

// Make content transitions faster by using a lower duration
      if (progress >= 20) {
        gsap.to(".jd-overlay-content", {
          opacity: 0,
          duration: 0.3
        });
      } else {
        gsap.to(".jd-overlay-content", {
          opacity: 1,
          duration: 0.3
        });
      }

      if (progress >= 80) {
        gsap.to(".jd-video-content", {
          opacity: 1,
          duration: 0.3
        });
      } else {
        gsap.to(".jd-video-content", {
          opacity: 0,
          duration: 0.3
        });
      }
    }

    let triggerElement = $(".jd-benefits");

    if (window.innerWidth < 501) {
      let tl = gsap
        .timeline({
          scrollTrigger: {
            trigger: ".jd-benefits",
            start: "top top",
            end: "200%", // Reduced from 300%
            scrub: 0.5, // Added specific scrub value for faster response
            pin: true,
            onUpdate: (self) => jdSetContentElements(self.progress.toFixed(2) * 100)
          }
        })
        .fromTo(".jd-overlay-bg", {maskSize: '250%'}, {maskSize: "3500%"}, "+=0.1" // Reduced from 0.2
        )
        .fromTo(".jd-compass", {
          scale: 1,
          width: "95vw"
        }, {
          scale: 15,
          rotation: 720,
          duration: 0.8
        }, // Added duration
            "<")
        .fromTo("#jd-circle-video", {scale: 0.4}, {scale: 1}, "-=0.5" // Changed from -=1
        );
    } else if (window.innerWidth < 990) {
      let tl = gsap
        .timeline({
          scrollTrigger: {
            trigger: ".jd-benefits",
            start: "top top",
            end: "200%", // Reduced from 300%
            scrub: 0.5,
            pin: true,
            onUpdate: (self) => jdSetContentElements(self.progress.toFixed(2) * 100)
          }
        })
        .fromTo(".jd-overlay-bg", {maskSize: '220%'}, {maskSize: "2700%"}, "+=0.1")
        .fromTo(".jd-compass", {scale: 1}, {
          scale: 15,
          rotation: 720,
          duration: 0.8
        }, "<")
        .fromTo("#jd-circle-video", {scale: 0.4}, {scale: 1}, "-=0.5");
    } else {
      let tl = gsap
        .timeline({
          scrollTrigger: {
            trigger: ".jd-benefits",
            start: "top top",
            end: "300%", // Reduced from 500%
            scrub: 0.5,
            pin: true,
            onUpdate: (self) => jdSetContentElements(self.progress.toFixed(2) * 100)
          }
        })
        .fromTo(".jd-overlay-bg", {maskSize: '100%'}, {maskSize: "1500%"}, "+=0.1")
        .fromTo(".jd-compass", {scale: 1}, {
          scale: 15,
          rotation: 720,
          duration: 0.8
        }, "<")
        .fromTo("#jd-circle-video", {scale: 0.4}, {scale: 1}, "-=0.5");
    }

// Optimized background scroll
    gsap.to("body", {
        backgroundPosition: `50% ${ - innerHeight / 10
      }px`,
      ease: "none",
      scrollTrigger: {
        trigger: "body",
        start: "top top",
        scrub: 0.5 // Added specific scrub value
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
